module.exports = __webpack_public_path__ + "img/type--3-spans--multiple-lang--en.da697a00.jpg";